import { render, staticRenderFns } from "./modalArea.vue?vue&type=template&id=1c8473bb&scoped=true&"
import script from "./modalArea.vue?vue&type=script&lang=js&"
export * from "./modalArea.vue?vue&type=script&lang=js&"
import style0 from "./modalArea.vue?vue&type=style&index=0&id=1c8473bb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8473bb",
  null
  
)

export default component.exports